export default "__VITE_ASSET__Cix6bvs4__"